import { Card, CardHeader, InteractionTag, InteractionTagPrimary, Subtitle2Stronger } from "@fluentui/react-components";
import OpenInNewIcon from "~icons/material-symbols/open-in-new";
import { FC } from "react";
import { IDocument } from "../../../interfaces";
import { EllipsisTooltip } from "../../EllipsisTooltip/EllipsisTooltip";
import { useClauseDocumentListStyles } from "../styles/ClauseDocumentList.styles";

type ClauseDocumentListProps = {
  documents: IDocument[];
  onOpenDocument?: (document: IDocument) => void;
};

export const ClauseDocumentList: FC<ClauseDocumentListProps> = ({ documents, onOpenDocument }) => {
  const styles = useClauseDocumentListStyles();

  if (!documents || documents.length === 0) return null;

  return (
    <Card appearance="subtle">
      <CardHeader header={<Subtitle2Stronger className={styles.documentHeader}>Document</Subtitle2Stronger>} />
      <div className={styles.fieldItem}>
        {documents.map((document) => (
          <InteractionTag key={document.doc_id} size="small" appearance="brand">
            <InteractionTagPrimary
              primaryText={
                <EllipsisTooltip content={document.doc_file_name}>
                  <span>
                    {document.doc_file_name} &nbsp; <OpenInNewIcon />
                  </span>
                </EllipsisTooltip>
              }
              onClick={() => onOpenDocument?.(document)}
            />
          </InteractionTag>
        ))}
      </div>
    </Card>
  );
};
